module.exports = __webpack_public_path__ + "Wireframes9.png?9e3a83d6608f5e2bd43d17a935b13dd6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Wireframes9.png
// module id = 123
// module chunks = 0